module.exports = __webpack_public_path__ + "img/icon_ideal_value.1b007977.svg";